import { RemoteTaskDelete } from 'data/usecases';
import { makeApiUrlTask } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteTaskDelete = (): RemoteTaskDelete => {
  return new RemoteTaskDelete(makeApiUrlTask(), makeAxiosHttpClient());
};
